import PropTypes from 'prop-types'
import React from 'react'
import clsx from 'clsx'
import { marginSizes } from '../../../configs/sizesConfig'
import * as validations from '../../../utils/validations'
import CheckboxDoubleField from '../../molecules/fields/CheckboxDoubleField'
import useTextValidation from '../../../hooks/useTextValidation'

const CheckboxDoubleCitizenField = ({
  name,
  index,
  payload,
  required,
  requiredOneRow,
  maxOneCol,
  disabled = false,
  margin = 'normal',
  optional
}) => {
  const translationText = useTextValidation()
  const label = index ? `${index}. ${payload?.label}` : payload?.label
  const validate = validations.mix(
    required && validations.required(translationText.required),
    requiredOneRow && validations.validateOnePerRow(payload?.rows.length, translationText.requiredOnePerRow),
    maxOneCol && validations.validateOnePerCol(translationText.maxOneCol)
  )

  return (
    <div className={clsx(marginSizes[margin], 'relative overflow-x-auto')}>
      <fieldset className="js-field-container">
        <CheckboxDoubleField
          hint={payload.hint}
          label={label}
          name={name}
          validate={validate}
          cols={payload.cols}
          rows={payload.rows}
          disabled={disabled}
          optional={optional}
        />
      </fieldset>
    </div>
  )
}

export default CheckboxDoubleCitizenField

CheckboxDoubleCitizenField.propTypes = {
  name: PropTypes.string,
  index: PropTypes.number,
  payload: PropTypes.object,
  required: PropTypes.bool,
  optional: PropTypes.bool,
  requiredOneRow: PropTypes.bool,
  maxOneCol: PropTypes.bool,
  disabled: PropTypes.bool,
  margin: PropTypes.string
}
